import React from 'react';
import { Box, Card, CardMedia, IconButton, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

interface ContractTemplateLogoGalleryProps {
  logoUrl?: string;
  onDelete?: () => void;
  showDeleteButton?: boolean;
}

const ContractTemplateLogoGallery = ({
  logoUrl,
  onDelete,
  showDeleteButton = false,
}: ContractTemplateLogoGalleryProps) => {
  if (!logoUrl) {
    return (
      <Box sx={{ textAlign: 'center', py: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Brak logo dla tego szablonu kontraktu
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
      <Card
        sx={{
          width: 200,
          height: 150,
          position: 'relative',
          '&:hover .delete-button': {
            opacity: showDeleteButton ? 1 : 0,
          },
        }}
      >
        <CardMedia
          component="img"
          height="150"
          image={logoUrl}
          alt="Logo szablonu kontraktu"
          sx={{ objectFit: 'contain', backgroundColor: '#f5f5f5' }}
        />
        {showDeleteButton && onDelete && (
          <IconButton
            className="delete-button"
            onClick={onDelete}
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              opacity: 0,
              transition: 'opacity 0.2s',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
              },
            }}
            size="small"
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        )}
      </Card>
    </Box>
  );
};

export default ContractTemplateLogoGallery;
